// Tax Simulator — the page. The simulator itself lives in TaxSimulatorPanel so
// the Rules editor can run the SAME component, with the same math, beside the
// rule being written. Anything that belongs to the page and not the tool (the
// route, the back link, the title) stays here.

import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { Fullbleed } from '@/contexts/fullbleed';
import { EntityIndexHeader } from '@/components/layouts';
import { TaxSimulatorPanel } from '@/components/organisms/taxes/TaxSimulatorPanel';

export const Route = createFileRoute('/_dashboard/dashboard/taxes/simulator')({
  component: TaxSimulatorPage,
  validateSearch: (search: Record<string, unknown>) => ({
    zip: typeof search.zip === 'string' ? search.zip : undefined,
  }),
});

function TaxSimulatorPage() {
  const { zip } = Route.useSearch();
  return (
    <>
      <Fullbleed />
      <div className="page-enter flex h-full min-h-0 flex-col">
        <EntityIndexHeader
          title={
            <div className="flex min-w-0 items-center gap-2">
              <Button asChild variant="ghost" size="icon-sm" title="Back to Taxes">
                <Link to="/dashboard/taxes">
                  <ArrowLeft size={14} />
                </Link>
              </Button>
              <h1 className="truncate text-base font-semibold">Tax Simulator</h1>
            </div>
          }
        />
        <TaxSimulatorPanel initialZip={zip} className="min-h-0 flex-1" />
      </div>
    </>
  );
}
